import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { textareaFocusHandler } from 'utils/focusHandler';

const Textarea = styled.textarea`
  padding: 12px;
  width: 100%;
  color: var(--gray-gray-09, #1b1c1e);

  border-radius: 8px;
  border: 1px solid var(--gray-gray-04, #dbdcdf);
  background: var(--Static-White, #fff);

  /* Body/B-16-Regular */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 137.5% */
  letter-spacing: -0.6px;
  resize: none;

  &::placeholder {
    color: #c2c4c8;
  }

  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera*/
  }

  &::after {
    content: '';
    position: relative;
    z-index: 1 !important; /* 커서의 z-index 설정 */
  }
`;

interface Props extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const CurriculumTextarea = (props: Props) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  return (
    <Textarea
      ref={textareaRef}
      onFocus={() => textareaFocusHandler(textareaRef)}
      {...props}
    />
  );
};

export default CurriculumTextarea;
